// ** React Imports
/* eslint-disable  */
import { Outlet } from "react-router-dom";
import React, { useState, useEffect } from "react";
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/HorizontalLayout";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getAllMenu } from "../redux/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// ** Menu Items Array
import navigation from "@src/navigation/horizontal";
import {
  Mail,
  MessageSquare,
  CheckSquare,
  Calendar,
  FileText,
  Circle,
  ShoppingCart,
  User,
  Shield,
  Square,
  Box,
  DollarSign,
  Percent,
  Star,
  Map,
  Slash,
} from "react-feather";
const HorizontalLayout = (props) => {
  // const [menuData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  const dispatch = useDispatch();
  const [menuData, setMenuData] = useState([]);
  const store = useSelector((state) => state.layout, shallowEqual);

  // ** For ServerSide navigation

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") &&
      localStorage.getItem("accessToken");
    if (!token) {
      return;
    }

    // if (hasManyPermission(["owner"])) {
    const menuLocalStorage = localStorage.getItem("menu");

    if (menuLocalStorage) {
      getMenuLocal(menuLocalStorage);

      // setMenuData(JSON.parse(menuLocalStorage));
    } else {
      setTimeout(async () => {
        if (!store.menuFetched) {
          dispatch(getAllMenu()).then(async (response) => {
            const menuLocal = await getMenu(response?.payload?.data?.data);
            localStorage.setItem(
              "menu",
              JSON.stringify(response?.payload?.data?.data)
            );
            setMenuData(menuLocal);
          });
        } else {
          const menuLocal = await getMenu(store.menu);
          console.log("menuLocal", menuLocal);
          localStorage.setItem("menu", JSON.stringify(store.menu));
          setMenuData(menuLocal);
        }

        console.log(store);
      }, 2000);
    }
    // }
  }, []);

  const getMenuLocal = async (menuLocalStorage) => {
    if (!menuLocalStorage) {
      return;
    }

    const menuLocal = await getMenu(JSON.parse(menuLocalStorage));
    setMenuData(menuLocal);
  };

  const getMenu = async (response) => {
    try {
      const modifiedData = await response.map((item) => ({
        ...item,
        // icon: React.createElement(iconComponents[item.iconName], {
        //   size: 20,
        // }),

        icon: <FontAwesomeIcon icon={`fa-solid ${item.iconName}`} />,
        id: item.key,
      }));
      console.log(
        "modifiedDatamodifiedDatamodifiedDatamodifiedData",
        modifiedData
      );

      for (const item of modifiedData) {
        if (item?.children?.length === 0) {
          delete item?.children;
        }
        delete item?.iconName;
        delete item?.iconSize;
        delete item?.sort;
      }
      return modifiedData;
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  );
};

export default HorizontalLayout;
